function getWSUrl(){
  if (process.env.RAILS_ENV == 'development') {
    return 'ws://localhost:3000/cable';
  } else {
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${window.location.host}/cable`;
  }
}

export {
  getWSUrl
}